import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import { Nodo } from './nodo';

import myGlobals = require('../config');

@Injectable()
export class NodoService {

  private nodoUrl =myGlobals.default.BASE_URL+'/nodo/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todos los nodos habilitados para el usuario
  getNodosInfoBasica() {
    return this.http.get(this.nodoUrl+"infoBasica/todo")
               .map((response) => response.json());
  }

  //Obtener todos los nodos habilitados para el usuario
  getNodos() {
    return this.http.get(this.nodoUrl)
        .map((response) => response.json());
  }


  //Obtener un nodo
  getNodo(_id: string): Observable<Nodo>  {
    return this.http.get(this.nodoUrl+_id)
               .map((response) => response.json());
  }

  //Obtener nodos by sucursal
  getNodosBySucursal(_id: string) {
    return this.http.get(this.nodoUrl+"sucursal/"+_id)
               .map((response) => response.json());
  }

  //Obtener nodos by gateway
  getNodosByGateway(_id: string) : Observable<Nodo[]>{
    return this.http.get(this.nodoUrl+"gateway/"+_id)
               .map((response) => response.json());
  }

  save(nodo: Nodo): Observable<Nodo>  {
    if (nodo._id) {
      return this.put(nodo);
    }
    //Seteo estado activo
    nodo.estado=true;
    return this.post(nodo);
  }

  //Desactivar nodo
  delete(nodo: Nodo) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.nodoUrl}/${nodo._id}`;

    return this.http
               .delete(url, {headers: headers})
               .map((response) => response.json());
  }

    //Eliminar nodo
    deleteStrict(nodo: Nodo) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        let url = `${this.nodoUrl}/${nodo._id}/true`;

        return this.http
            .delete(url, {headers: headers});
    }

  // Agregar nuevo nodo
  private post(nodo: Nodo):Observable<Nodo> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'});
    headers.append('dataType', 'json');
    var nodoStr=JSON.stringify(nodo);
    return this.http
               .post(this.nodoUrl, nodoStr, {headers: headers})
                .map((response) => response.json());
  }

  // Actualizar nodo
  private put(nodo: Nodo) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.nodoUrl}/${nodo._id}`;

    return this.http
               .put(url, JSON.stringify(nodo), {headers: headers})
               .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/nodo/nodo.service.ts